import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router';

const THEME_KEY = 'cvr.theme';

function readTheme() {
  try {
    return localStorage.getItem(THEME_KEY) || '';
  } catch {
    return '';
  }
}

// The layout of each page. The error page passes its message as `children`.
export default function App({ children }) {
  const [theme, setTheme] = useState(readTheme);
  const { pathname } = useLocation();

  useEffect(() => {
    if (theme) document.documentElement.dataset.theme = theme;
    else delete document.documentElement.dataset.theme;
    try {
      if (theme) localStorage.setItem(THEME_KEY, theme);
      else localStorage.removeItem(THEME_KEY);
    } catch {
      // Storage can be blocked. The theme then lasts for this page load only.
    }
  }, [theme]);

  function toggleTheme() {
    const dark = theme ? theme === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
    setTheme(dark ? 'light' : 'dark');
  }

  // "/" and "/Companies" are the same page, so both mark the Companies tab.
  const companiesActive = pathname === '/' || pathname.startsWith('/Compan');

  return (
    <>
      <header className="topbar">
        <Link to="/" className="brand" aria-label="CVR register home">
          <span className="brand-mark">CVR</span>
          <span className="brand-name">CVR register</span>
        </Link>
        <nav className="nav">
          <NavLink to="/Companies" className={companiesActive ? 'active' : undefined}>Companies</NavLink>
          <NavLink to="/People" className={({ isActive }) => (isActive || pathname.startsWith('/Person') ? 'active' : undefined)}>People</NavLink>
          <NavLink to="/Financials">Financials</NavLink>
        </nav>
        <button type="button" className="icon-btn" onClick={toggleTheme} title="Toggle the theme" aria-label="Toggle the theme">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </svg>
        </button>
      </header>
      <main className="main">
        {children ?? <Outlet />}
      </main>
      <footer className="footer">Data from the Danish CVR register, served by kinedb.</footer>
    </>
  );
}
